// «Dichiarazioni AD-1» del menu: una riga per dichiarazione dell'anno, con stato e termine.
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { useDatiQuadro } from '../home/useDatiQuadro'
import { Stato } from '../home/Strumenti'
import { dataItaliana, righeDichiarazioniElenco, statoDichiarazione, type RigaTabella } from '../home/quadro'
import { ANNO_IMPOSTA } from '../lib/anno-imposta'
import { ETICHETTA_PERIODO } from '../impianti/stato-dichiarazione'
import type { DichiarazioneInElenco } from './dichiarazione.api'

const FILTRI = [
  { chiave: 'da_fare', etichetta: 'Da fare', vale: (_: RigaTabella, d: DichiarazioneInElenco) => d.stato !== 'inviata' },
  { chiave: 'in_ritardo', etichetta: 'In ritardo o rifiutate', vale: (r: RigaTabella) => r.tono === 'rosso' },
  { chiave: 'inviate', etichetta: 'Inviate', vale: (_: RigaTabella, d: DichiarazioneInElenco) => d.stato === 'inviata' },
  { chiave: 'tutte', etichetta: 'Tutte', vale: () => true },
] as const

export function ElencoDichiarazioni() {
  const idPartner = Number(useParams().idPartner)
  const base = `/cliente/${idPartner}`
  // Il filtro vive nell'indirizzo, come nell'elenco impianti: il collegamento si condivide.
  const [parametri, setParametri] = useSearchParams()
  const filtro = FILTRI.find((f) => f.chiave === parametri.get('filtro')) ?? FILTRI[0]
  const { dichiarazioni, termini } = useDatiQuadro(idPartner)

  const righe = righeDichiarazioniElenco(dichiarazioni, termini, ANNO_IMPOSTA)
    .map((r, i) => ({ riga: r, d: dichiarazioni[i]! }))
    .filter(({ riga, d }) => filtro.vale(riga, d))
    // In testa cio' che scade prima; le righe senza termine in fondo.
    .sort((a, b) => (a.riga.scadenza ?? '9999').localeCompare(b.riga.scadenza ?? '9999'))

  return (
    <div className="cruscotto">
      <header className="cruscotto-testata">
        <h1>Dichiarazioni AD-1</h1>
        <p>Anno d'imposta {ANNO_IMPOSTA} · termine di presentazione dalle regole dell'anno</p>
      </header>

      <nav className="filtri" aria-label="Filtra le dichiarazioni">
        {FILTRI.map((f) => (
          <button
            key={f.chiave}
            type="button"
            aria-pressed={f.chiave === filtro.chiave}
            onClick={() => setParametri({ filtro: f.chiave }, { replace: true })}
          >
            {f.etichetta}
          </button>
        ))}
      </nav>

      <section className="riquadro" aria-label="Elenco delle dichiarazioni">
        {righe.length === 0 ? (
          <p>
            Nessuna dichiarazione in questo elenco. Le dichiarazioni dell'anno si aprono dalla scheda di ogni{' '}
            <Link to={`${base}/impianti`}>impianto</Link>.
          </p>
        ) : (
          <div className="tabella-scorre">
            <table className="tabella-quadro">
              <thead>
                <tr>
                  <th>Impianto</th>
                  <th>Periodo</th>
                  <th>Stato</th>
                  <th>Termine</th>
                  <th>Residui</th>
                  <th><span className="solo-lettori">Azione</span></th>
                </tr>
              </thead>
              <tbody>
                {righe.map(({ riga, d }) => {
                  const stato = statoDichiarazione(d.stato)
                  return (
                    <tr key={riga.chiave} className={riga.tono === 'rosso' ? 'riga-rosso' : riga.tono === 'ambra' ? 'riga-ambra' : undefined}>
                      <td>
                        <Link to={`${base}/impianti/${d.impiantoId}`}>{d.impianto}</Link>
                        <small>{d.cliente}</small>
                      </td>
                      <td>{ETICHETTA_PERIODO[d.periodo].replace(/^./, (c) => c.toUpperCase())}</td>
                      <td><Stato tono={stato.tono}>{stato.testo}</Stato></td>
                      <td>{riga.scadenza ? dataItaliana(riga.scadenza) : '—'}</td>
                      <td><Stato tono={riga.tono}>{riga.residui}</Stato></td>
                      <td><Link to={`${base}/${riga.rotta}`}>Apri</Link></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  )
}
